export default "assets/images/icons/file-0f61f956.svg";